<template>
  <div class="sessionColorSettings colorGroup">
    <ColorPicker :default="''" @updateColor="setColor" />
    <button
      v-for="(color, index) in colors"
      :key="index"
      class="color"
      :style="`background-color:${color}`"
      @click="setColor(color)"
    ></button>
  </div>
</template>

<script>
import ColorPicker from "../../../../BookingPages/Settings/Customizer/Background/BackgroundComponents/ColorPicker";

export default {
  name: "SessionColorPicker",
  props: {
    colors: Array,
  },
  components: {
    ColorPicker,
  },
  methods: {
    setColor(color) {
      this.$emit("setColor", color);
    },
  },
};
</script>

<style>
.sessionColorSettings .color {
  margin-top: 15px;
  box-sizing: border-box;
  padding: 15px;
  padding-bottom: 5px;
  border-radius: 360px;
  width: 55px;
  height: 55px;
  box-shadow: 0px -1px 4px 0px #d8d8d8ab, 0px 1px 4px 0px #cacaca9e;
  border: 2px solid transparent;
}
.sessionColorSettings .color:hover {
  border-color: #eaeaeaef;
  box-shadow: none;
}
.sessionColorSettings {
  display: grid;
  grid-gap: 1px;
  grid-template-columns: repeat(9, 1fr);
}
</style>